import { useTranslation } from "react-i18next";

import { HaNResultList } from "../../shared/HaNResultList/HaNResultList";
import { useOpenResult } from "../../shared/useOpenResult";
import { RoomCell } from "../RoomCell";
import { useRoomsModel } from "../useRoomsModel";

// The selected floor's rooms. Once loaded they stay on screen while a refresh loads newer ones.
export const RoomsOnFloor = () => {
  const { t } = useTranslation();
  const { status, rooms } = useRoomsModel();
  const openResult = useOpenResult();

  if (status === "loading") return <HaNResultList.Loading />;
  if (rooms.length === 0) return <HaNResultList.Empty text={t("hereAndNow:NoRoomsAvailable")} />;

  return (
    <HaNResultList>
      {rooms.map(room => (
        <HaNResultList.Item
          key={room.id}
          nodeId={room.id}
          onSelect={() => openResult("room", room)}>
          <RoomCell room={room} />
        </HaNResultList.Item>
      ))}
    </HaNResultList>
  );
};
